module.exports = __webpack_public_path__ + "img/40_69_012_370.856fa620.jpg";